import { SimpleTableStyled } from './SimpleTable.styles';
import { ReactNode } from 'react';
type Cell = ReactNode | string | number;

interface Props {
  rows: Array<Array<Cell>>;
  columns: Array<Cell>;
}

export const SimpleTable = ({ rows, columns, ...props }: Props) => (
  <SimpleTableStyled {...props}>
    <thead>
      <tr>
        {columns.map((column, i) => (
          <th key={`simple-table-header-${i}`}>{column}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.map((row, rowIndex) => (
        <tr key={rowIndex}>
          {row.map((cell, cellIndex) => (
            <td key={`simple-table-row-${rowIndex}-cell-${cellIndex}`}>
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </SimpleTableStyled>
);
